
import { NavLink, Outlet, useLocation, Navigate } from 'react-router-dom'
import { Activity, Camera, TrendingDown } from 'lucide-react'

export function ObservabilityLayout() {
    const location = useLocation()

    // Redirect to runtime if exact match on /rag/observability
    if (location.pathname === '/rag/observability' || location.pathname === '/rag/observability/') {
        return <Navigate to="/rag/observability/runtime" replace />
    }

    return (
        <div className="flex flex-col h-full bg-[#0A0A0A]">
            {/* Sub-Navigation Header */}
            <div className="flex-shrink-0 border-b border-white/10 bg-[#0F0F0F]">
                <div className="px-6 flex gap-6">
                    <TabLink
                        to="/rag/observability/runtime"
                        icon={<Camera className="w-4 h-4" />}
                        label="Runtime State"
                    />
                    <TabLink
                        to="/rag/observability/heartbeat"
                        icon={<Activity className="w-4 h-4" />}
                        label="System Heartbeat"
                    />
                    <TabLink
                        to="/rag/observability/degradation"
                        icon={<TrendingDown className="w-4 h-4" />}
                        label="Degradation Status"
                    />
                </div>
            </div>

            {/* Content Area */}
            <div className="flex-1 overflow-y-auto">
                <Outlet />
            </div>
        </div>
    )
}

function TabLink({ to, icon, label }: { to: string; icon: React.ReactNode; label: string }) {
    return (
        <NavLink
            to={to}
            className={({ isActive }) =>
                `flex items-center gap-2 py-4 px-2 border-b-2 transition-all text-sm ${isActive
                    ? 'text-white font-medium border-blue-500'
                    : 'text-gray-400 border-transparent hover:text-gray-300 hover:border-white/10'
                }`
            }
        >
            {icon}
            <span>{label}</span>
        </NavLink>
    )
}
